var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* istanbul ignore file */
import * as React from "react";
import { observer } from "mobx-react";
let DatePart = class DatePart extends React.Component {
    render() {
        let jackpot = this.props.jackpot, dict = this.props.dict, datePartConfig = this.props.datePartConfig;
        let labels = jackpot.CountdownState.isMoreThan24hLeft
            ? [dict.DaysToDrop, dict.HoursToDrop, dict.MinutesToDrop]
            : [dict.HoursToDrop, dict.MinutesToDrop, dict.SecondsToDrop];
        const hideLearnMoreBtn = datePartConfig ? datePartConfig.hideLearnMoreBtn : false;
        if (jackpot.updatingData.IsWon) {
            return (React.createElement("div", { className: "rj-jackpot__item-description rj-jackpot__item-description--won" }, dict.SomeoneWonJackpot));
        }
        return (React.createElement(React.Fragment, null, !jackpot.IsCountdownType ?
            this.renderRegularType(dict, hideLearnMoreBtn, jackpot) :
            this.renderCountDownType(jackpot, labels)));
    }
    renderRegularType(dict, hideLearnMoreBtn, jackpot) {
        return (React.createElement("div", { className: "rj-jackpot__item-description rj-jackpot__item-description--must-drop" },
            dict.MustDropBefore,
            " ",
            jackpot.MustDropBeforeDate,
            " ",
            React.createElement("br", null),
            !hideLearnMoreBtn && React.createElement("button", { className: "rj-jackpot__item-description-button" }, dict.LearnMore)));
    }
    renderCountDownType(jackpot, labels) {
        if (!!jackpot.CountdownState.parts.length) {
            return (React.createElement("div", { className: "rj-jackpot__item-description rj-jackpot__item-description--counter" }, jackpot.CountdownState.parts.map((item, ind) => {
                return (React.createElement("div", { key: ind, className: "rj-jackpot__item-counter" },
                    labels[ind],
                    React.createElement("div", { className: "rj-jackpot__item-counter-value" }, item)));
            })));
        }
        return React.createElement(React.Fragment, null);
    }
};
DatePart = __decorate([
    observer
], DatePart);
export { DatePart };
//# sourceMappingURL=DatePart.js.map